export enum SplitMode {
    qr = 1,
    every = 2,
    second = 3,
    manual = 4,
    put = 5,
}
export enum DroppableId {
    UploadedDocuments = "uploaded-documents",

    ParkedPages = "parked-pages",
    InvisiblePages = "invisible-pages",
    AllPages = "all-pages",
    Carousel = "Carousel",
}

export enum PageSource {
    PARKED = "PARKED",
    UPLOADED = "UPLOADED",
    LISTED = "LISTED",
}

export enum PdfToolsPaths {
    Stats = "statistics",
}
